import React from "react";
import "./GetMusicOnFacebook.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnFacebook = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload music & artwork",
    "Select Facebook & Instagram",
    "Release approved by stores",
    "Go live worldwide",
    "Earn from content usage"
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Your Music on Facebook & Instagram | Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music to Facebook and Instagram with FT Tunes. Get your songs available on Reels, Stories and creator library worldwide."
        />

        <meta
          name="keywords"
          content="Facebook music distribution, upload music to Facebook, Instagram music distribution, Facebook reels music, FT Tunes"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="facebook-page">

        {/* HERO */}
        <section className="facebook-hero">
          <Container>

            <img
              src="/Images/facebook-logo.png"
              alt="Facebook Distribution"
              className="facebook-logo"
            />

            <h1>Get Your Music on Facebook & Instagram</h1>

            <p>
              Share your music across Facebook and Instagram Reels,
              Stories, and videos. Let creators worldwide use your
              songs and grow your audience organically.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-facebook"></div>
        </section>


        {/* SHOWCASE */}
        <section className="facebook-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Music Meets Social Media</h2>

                <p>
                  Facebook and Instagram allow creators to use your
                  music in millions of videos daily. Increase visibility,
                  engagement and fan discovery through social sharing.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-facebook.png"
                  alt="Facebook Music Platform"
                  className="facebook-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="facebook-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="facebook-benefits">
          <Container>

            <h2 className="section-title">
              Why Release Music on Facebook?
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Massive Reach</h5>
                  <p>Billions of Facebook & Instagram users.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Reels & Stories</h5>
                  <p>Your music used in trending short videos.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Artist Discovery</h5>
                  <p>Boost engagement and fan growth.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Earn Revenue</h5>
                  <p>Monetize music usage worldwide.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="facebook-cta">
          <Container>

            <h2>Release Your Music on Facebook Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnFacebook;